import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type {
	DecksSearchParams,
	SearchDecksSection,
	WithCounts,
} from "src/api/search";
import { searchDecks } from "src/api/search";
import { DecksSize } from "src/hooks/useFlashcards";

import options from "./defaultOptions";

export function useDecksSearch(
	searchValue: string,
	params: Omit<DecksSearchParams, "take">,
) {
	return useQuery<WithCounts<SearchDecksSection>, Error>({
		queryKey: ["decks-search", searchValue, params],
		queryFn: () => searchDecks(searchValue, { ...params, take: DecksSize }),
		...options,
		placeholderData: keepPreviousData,
	});
}
